// extracted by mini-css-extract-plugin
export var description = "description_list_item-module--description--0dqmn";
export var descriptionTitle = "description_list_item-module--descriptionTitle--hZAhb";
export var subList = "description_list_item-module--subList--8OcsP";